<template>
  <v-col
    cols="12"
    sm="12"
  >
    <presentations :section="2" />
  </v-col>
</template>

<script>
import { mapState } from 'vuex';
import Presentations from '@/components/Presentations';

export default {
  name: 'PresentationsList',
  components: {
    Presentations,
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapState({
      usersStore: state => state.usersStore,
    }),
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      
    },

  },
};
</script>

<style scoped>
  .clickable{
    cursor:pointer;
  }
  button {
    outline: none;
  }
</style>
